import { render, staticRenderFns } from "./LiveDateTime.vue?vue&type=template&id=65fa5b44&scoped=true&"
import script from "./LiveDateTime.vue?vue&type=script&lang=js&"
export * from "./LiveDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fa5b44",
  null
  
)

export default component.exports